<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.componentSettingsLoading"
    :disabled="admin.componentSettingsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5"> Delete Setting ({{ id }})? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteComponentSetting">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedComponentSetting == null"></v-card-text>
    <v-card-text v-show="admin.selectedComponentSetting != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Setting saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.attributeList"
          label="Attribute"
          outlined
          item-text="name"
          item-value="id"
          v-model="attributeId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-text-field
          v-model="label"
          :rules="validation.length50"
          label="Label"
          required
        ></v-text-field>
        <v-text-field v-model="valueSuffix" label="Value Suffix"></v-text-field>
        <v-textarea
          outlined
          v-model="sigMessage"
          label="Sig Message"
        ></v-textarea>
        <v-checkbox
          color="blue darken-2"
          v-model="required"
          label="Required"
        ></v-checkbox>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedComponentSetting != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveComponentSetting"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteSetting"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedComponentSetting &&
            this.admin.selectedComponentSetting.id != 'new'
          ) {
            tabName = `Edit Setting ${this.admin.selectedComponentSetting.label}`;
          } else if (
            this.admin.selectedComponentSetting &&
            this.admin.selectedComponentSetting.id == 'new'
          ) {
            tabName = 'Add New Setting';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedComponentSetting?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'id',
            value: value
          });
        }
      },
      componentId: {
        get() {
          return this.admin.selectedComponentSetting?.componentId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'componentId',
            value: Number(value)
          });
        }
      },
      attributeId: {
        get() {
          return this.admin.selectedComponentSetting?.attributeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'attributeId',
            value: Number(value)
          });
        }
      },
      label: {
        get() {
          return this.admin.selectedComponentSetting?.label;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'label',
            value: value
          });
        }
      },
      valueSuffix: {
        get() {
          return this.admin.selectedComponentSetting?.valueSuffix;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'valueSuffix',
            value: value
          });
        }
      },
      sigMessage: {
        get() {
          return this.admin.selectedComponentSetting?.sigMessage;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'sigMessage',
            value: value
          });
        }
      },
      required: {
        get() {
          return this.admin.selectedComponentSetting?.required;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'required',
            value: Boolean(value)
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedComponentSetting?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedComponentSetting',
            property: 'published',
            value: Boolean(value)
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a component
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedComponentSetting', null);
      },
      /**
       * Saves the component currently being edited
       */
      saveComponentSetting() {
        this.$store.dispatch('admin/saveSelectedComponentSetting').then(() => {
          this.showSaveOverlay = true;
          // refresh component list
          this.$store.dispatch('admin/getComponentSettingList');
          setTimeout(() => {
            this.showSaveOverlay = false;
          }, 1500);
        });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteSetting() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product setting
       */
      deleteComponentSetting() {
        this.$store
          .dispatch('admin/deleteComponentSetting', this.id)
          .then(() => {
            this.$store.dispatch('admin/getComponentSettingList');
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedComponentSetting', null);
          });
      }
    }
  };
</script>

<style scoped></style>
